var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-statistic',{attrs:{"icon":"euro_symbol","title":_vm.$t('customs.dashboard.totalSales'),"sub-title":_vm.subtitle,"value":_vm.periodDiffPositiveValue,"text":_vm.formatPrice(_vm.totalRevenues, _vm.currency),"color":_vm.color,"caption":_vm.periodDiffIsInfinity
      ? ''
      : _vm.$t('customs.dashboard.previousPeriod') + ' ' + _vm.formatPrice(_vm.totalRevenuesPrevious, _vm.currency),"is-negative":Math.sign(_vm.percentagePeriodDiff) !== 1,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }